import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../Store/store";
import { setPagePermissions } from "../Store/Reducers/AuthModule/auth";

import { fetchPermissionForUser } from "../Network/Core/pagePermission";

import { errorHandling } from "../Library/Utils";

const useManagerPagePermission = () => {
  const [callFetchPermission, setCallFetchPermission] =
    useState<boolean>(false);

  const userId = useSelector(
    (state: RootState) =>
      state?.authReducer?.userDetails?.page_level_permission_id
  );

  const dispatch = useDispatch();

  const defaultPermissions = {
    review: false,
    forecast: false,
    planning: false,
    strategy: false,
    settings: false,
    feedback: false};

  const getCurrUserPagePermission = async () => {
    setCallFetchPermission(false);
    if (userId) {
      try {
        const response = await fetchPermissionForUser(userId);
        if (response?.data?.success) {
          dispatch(setPagePermissions(response.data?.data?.page_permissions));
        } else {
          dispatch(setPagePermissions(defaultPermissions));
        }
      } catch (e) {
        errorHandling(e);
      }
    } else {
      dispatch(setPagePermissions(defaultPermissions));
    }
  };

  useEffect(() => {
    setCallFetchPermission(true);
  }, [userId]);

  useEffect(() => {
    if (callFetchPermission) getCurrUserPagePermission();
  }, [callFetchPermission]);

  return {
    setCallFetchPermission};
};

export default useManagerPagePermission;
